import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/student-scholarship',
    name: 'studentScholarship',
    component: () => import('@/views/student-scholarship/StudentScholarship.vue'),
    meta: {
      pageTitle: 'Danh sách nhận học bổng',
      breadcrumb: [
        {
          text: 'Công tác Học sinh - Sinh viên',
          active: false,
        },
        {
          text: 'Danh sách nhận học bổng',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.STUDENTSCHOLARSHIP,
    },
  },
  {
    path: '/eligible-student-scholarship',
    name: 'eligibleStudentScholarship',
    component: () => import('@/views/student-scholarship/EligibleStudentScholarship.vue'),
    meta: {
      pageTitle: 'Danh sách sinh viên đủ điều kiện nhận học bổng',
      breadcrumb: [
        {
          text: 'Công tác sinh viên',
          active: false,
        },
        {
          text: 'Danh sách sinh viên đủ điều kiện nhận học bổng',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.ELIGIBLE_STUDENT_SCHOLARSHIP,
    },
  },
  {
    path: '/scholarship-budget',
    name: 'scholarshipBudget',
    component: () => import('@/views/scholarship-budget/ScholarshipBudget.vue'),
    meta: {
      pageTitle: 'Danh sách phân bổ học bổng',
      breadcrumb: [
        {
          text: 'Công tác Học sinh - Sinh viên',
          active: false,
        },
        {
          text: 'Danh sách phân bổ học bổng',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.SCHOLARSHIP_BUDGET,
    },
  },
]
